import { faq } from '@/data/faq';
import { localeStore } from '@/locale';
import { atom } from 'nanostores';

export class FaqStore {
  $openedSet = atom(new Set());

  store;

  constructor(store) {
    this.store = store;
  }

  init() {
    this.resetOpenStates();
  }

  resetOpenStates() {
    const items = faq[localeStore.lang];

    const openedSet = new Set();
    items.forEach((item) => {
      if (item.isDefaultOpened) openedSet.add(item.id);
    });
    this.$openedSet.set(openedSet);
  }

  open(id) {
    const openedSet = new Set([...this.$openedSet.get()]);
    openedSet.add(id);
    this.$openedSet.set(openedSet);
  }

  close(id) {
    const openedSet = new Set([...this.$openedSet.get()]);
    openedSet.delete(id);
    this.$openedSet.set(openedSet);
  }

  toggle(id) {
    const openedSet = new Set([...this.$openedSet.get()]);
    if (openedSet.has(id)) openedSet.delete(id);
    else openedSet.add(id);
    this.$openedSet.set(openedSet);
  }

  closeAll() {
    this.$openedSet.set(new Set());
  }
}
